module.exports = __webpack_public_path__ + "media/images/hitfun3/icon.prize.certificate-e0104dccec62bfdc619451817abaf187.svg";